export const trustpilot = ['24 24', `
  <title>Trustpilot icon</title>
  <path xmlns="http://www.w3.org/2000/svg" d="M12,17.964l5.214-1.321l2.179,6.714L12,17.964z M24,9.286h-9.179L12,0.643L9.179,9.286 H0l7.429,5.357l-2.821,8.643l7.429-5.357l4.571-3.286L24,9.286L24,9.286L24,9.286L24,9.286z"/>
`]
